



























































































import { Component, Vue } from 'vue-property-decorator';
import BaseVue from '@/core/BaseVue';
import GenericEdit from '@/core/Generics/GenericEdit';
import ResearchLine from "@/models/coding/researchLine/researchLine.model";
@Component
export default class ResearchLineEdit extends GenericEdit<ResearchLine> {
  constructor() {
    super();
    this.controller = 'ResearchLines';
    this.model = new ResearchLine();
  }
  saveAll(){
      this.model.fieldAreaId = this.$route.params.fieldAreaId as any;
      return this.validate();
  }
  public convertirAMinuscula(event: any) {
    this.model.key = event.target.value.toLowerCase();
  }
}
